const prodConfig = {
  MASTER_TOKEN: 'tGdp3GxthgOgEZkCnhgAYKqMt1vDkjrc',
  IMAGEURL: './public/images/',
  BASE_URL: window.location.protocol + '//' + window.location.hostname + '/api/'
};

module.exports = prodConfig;
